// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LPaV","question":"styles_question__1vRWS","inputVisibleButton":"styles_inputVisibleButton__5kwvJ","note":"styles_note__2WIBz"};